angular.module('elfium').filter('companyHasOtherAddress', function () {
    return function (otherAddress) {
        var hasOtherAddress = false;
        angular.forEach(otherAddress, function (fieldValue, fieldName) {
            if (fieldName != 'id' && fieldValue) {
                hasOtherAddress = true;
            }
        });
        return hasOtherAddress;
    };
});


            


// WEBPACK FOOTER //
// ./src/app/components/company/companyHasOtherAddressFilter.ts